export default class TrendingSearches {

	constructor () {
		this.trendingURL = `https://${window.SS_SITE_ID}.a.searchspring.io/api/suggest/trending?siteId=${window.SS_SITE_ID}`;
		this.limit = 3;
	}

	async getTrending () {
		const url = this.trendingURL + '&limit=' + this.limit;

		const response = await fetch(url, {
			headers: {
				'Content-Type': 'application/json'
			},
			method: 'GET'
		});


		if (!response.ok) {
			return false;
		}

		const jsonResponse = await response.json();

		if (!jsonResponse || !jsonResponse.trending.queries || jsonResponse.trending.queries.length === 0) {
			return false;
		}

		return jsonResponse.trending.queries;
	}
}
